import { baseCustomQuery } from '../baseQuery/baseCustomQuery';

const BASE_URL = process.env.https://admin.pharmanavigators.com/backend-platform/;

const basePlatformQuery = baseCustomQuery(BASE_URL)

export default basePlatformQuery;
